import React, { useState, useEffect, useRef, Suspense, useCallback  } from 'react';
import IASideBar from './IASideBar';
import * as mui from '@mui/material';
import ResponsiveContainer from '../../layout/Container';
import SearchAppBar from '../../common/Appbar';
import Separator from '../../layout/Separator';
import BugReportIcon from '@mui/icons-material/BugReport';
import auditService from '../../../services/AuditService';
import DynamicDrawer from '../../common/Drawer';
import CustomSpeedDial from '../../common/SpeedDial';
import NormalTextField from '../../common/NormalTextField';
import MultipleSelect from '../../common/MultipleSelect';
import DynamicSnackbar from '../../common/Snackbar';
import DataTable from '../../common/DataGrid';
import ExpandableDataGrid from '../../common/ExpandableDataGrid';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import GppGoodIcon from '@mui/icons-material/GppGood';
import StairsIcon from '@mui/icons-material/Stairs';
import Modal from '../../common/Modal';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Importing Quill's default snow theme
import DOMPurify from 'dompurify';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PagesIcon from '@mui/icons-material/Pages';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import CircularProgress from '@mui/material/CircularProgress';
import RuleIcon from '@mui/icons-material/Rule';


const ProcedureLibrary = () => {

    const [users, setUsers] = useState([]);
    const [apps, setApps] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [currentUser, setCurrentUser] = useState(null);
    const [error, setError] = useState(null);
    const [open, setOpen] = useState(false);
    const [controlsData, setControlsData] = useState([]);
    const [proceduresData, setProceduresData] = useState([]);
    const [newData, setNewData] = useState({});
    const [controlsType, setControlsType] = useState([]);
    const [controlID, setControlID] = useState([]);
    const [procedureCategory, setProcedureCategory] = useState([]);
    const [controlsDomain, setControlsDomain] = useState([]);
    const [controlsList, setControlsList] = useState([]);
    const [filteredList, setFilteredList] = useState([]);
    const [procedureDomain, setProceduresDomain] = useState([]);
    const [procedurePhase, setProceduresPhase] = useState([]);
    const [controlName, setControlName] = useState([]);
    const [selectedControl, setSelectedControl] = useState([]);
    const saveTimeout = useRef(null);
    const [controlsExist, setControlsExist] = useState([]);
    const [proceduresExist, setProceduresExist] = useState([]);

    const [designProcedure, setDesignProcedure] = useState('');
    const [interimProcedure, setInterimProcedure] = useState('');
    const [rollforwardProcedure, setRollForwardProcedure] = useState('');
    const [finalProcedure, setFinalProcedure] = useState('');

    const [expanded, setExpanded] = useState(true);

    const [anchorEl, setAnchorEl] = useState(null);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [selectedApp, setSelectedApp] = useState(null);
    const [existingProcedure, setExistingProcedure] = useState(false);

    const [openModal, setOpenModal] = useState(false);

    const label = { inputProps: { 'aria-label': 'Switch demo' } };

    const handleSwitchChange = (event) => {
        // Prevent the event from propagating to the AccordionSummary
        event.stopPropagation();
        // Handle the switch change logic here
    };

    const handleOpenModal = () => {
        setOpenModal(true);
    };

    const handleCloseModal = (event, reason) => {
        setOpenModal(false);
    };
    
    const handleClick = (event, app) => {
        console.log('Clicked row data:', app);
        
        // Try to match by string or number comparison since IDs might be different types
        const controlIdFromRow = app.CONTROL_ID;
        
        // Get the control object that matches the procedure's CONTROL_ID
        const controlToSelect = controlName.find(control => 
            String(control.value) === String(controlIdFromRow)
        );
        
        console.log('Procedure CONTROL_ID:', controlIdFromRow);
        console.log('Available controls:', controlName);
        console.log('Selected control object:', controlToSelect);
        
        if (controlToSelect) {
            // Set the control in the dropdown
            setSelectedControl(controlToSelect);
            setControlID(controlIdFromRow);
            localStorage.setItem('controlID', controlIdFromRow);
            
            // Set the procedure content
            setDesignProcedure(app.DESIGN_PROCEDURES || '');
            setInterimProcedure(app.INTERIM_PROCEDURES || '');
            setRollForwardProcedure(app.ROLLFORWARD_PROCEDURES || '');
            setFinalProcedure(app.FINAL_PROCEDURES || '');
            
            // Update the newData object
            setNewData({
                DESIGN_PROCEDURES: app.DESIGN_PROCEDURES || '',
                INTERIM_PROCEDURES: app.INTERIM_PROCEDURES || '',
                ROLLFORWARD_PROCEDURES: app.ROLLFORWARD_PROCEDURES || '',
                FINAL_PROCEDURES: app.FINAL_PROCEDURES || ''
            });
            
            setExistingProcedure(true);
            setOpenModal(true);
        } else {
            console.error('Could not find matching control for ID:', controlIdFromRow);
            console.log('Available control IDs:', controlName.map(c => c.value));
            setSnackbarMessage('Could not find the associated control');
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
        }
    };

    const toggleDrawer = (open) => () => {
        setOpen(open);
    };

    useEffect(() => {
        const fetchProcedures = async () => {
            try {
                const procedureList = await auditService.fetchProcedures();
             
                if (procedureList) {
                    setProceduresData(procedureList);
                    setProceduresExist(procedureList);
                }
            } catch (fetchError) {
                console.error('Error fetching apps:', fetchError);
                setProceduresData([]); 
                setProceduresExist([]);
            }
        };
        fetchProcedures();

        const fetchControls = async () => {
            let controls;
            try {
                controls = await auditService.fetchControls();
            } catch (fetchError) {
                console.error('Error fetching controls:', fetchError);
                setControlsList([]); 
            }

            if (controls) {
                const controlsformat = controls.map(item => ({
                    value: item.id,
                    label: item.CONTROL_TITLE,
                }));
                setControlName(controlsformat);
            }
        }

        fetchControls();
    }, []); 

    useEffect(() => {
        if (proceduresData.length > 0 && controlName.length > 0) {
            console.log("Validating control IDs in procedures...");
            
            // Create a set of valid control IDs for faster lookup
            const validControlIds = new Set(controlName.map(control => control.value));
            
            // Check each procedure's control ID
            proceduresData.forEach(procedure => {
                if (!validControlIds.has(procedure.CONTROL_ID)) {
                    console.warn(`Procedure ID ${procedure.id} has invalid CONTROL_ID: ${procedure.CONTROL_ID}`);
                }
            });
        }
    }, [proceduresData, controlName]);

    useEffect(() => {
        const isExistingControls = proceduresExist.some(procedures => procedures.PROCEDURE_NAME === proceduresData.PROCEDURE_NAME);
        if (isExistingControls) {
            setError('Procedure already exists');
        } else {
            setError('');
        }
    }, [proceduresData]); 


    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
    };

    const columns = [
        { field: 'id', headerName: '#', width: 50 },
        { field: 'CONTROL_TITLE', headerName: 'Control Name', flex: .5 },
        {
            field: 'DESIGN_PROCEDURES',
            headerName: 'Design Procedures',
            flex: 1,
            renderCell: (params) => (
              <div
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(params.value || '') }}
              />
            ),
          },

          {
            field: 'INTERIM_PROCEDURES',
            headerName: 'Interim Procedures',
            flex: 1,
            renderCell: (params) => (
              <div
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(params.value || '') }}
              />
            ),
          },

          {
            field: 'ROLLFORWARD_PROCEDURES',
            headerName: 'Rollforward Procedures',
            flex: 1,
            renderCell: (params) => (
              <div
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(params.value || '') }}
              />
            ),
          },

          {
            field: 'FINAL_PROCEDURES',
            headerName: 'Final Procedures',
            flex: 1,
            renderCell: (params) => (
              <div
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(params.value || '') }}
              />
            ),
          },
    ];

    const rows = Array.isArray(proceduresData) ? proceduresData.map((controls, index) => ({
        id: index + 1,
        CONTROL_TITLE: controls.CONTROL_TITLE || '-',
        DESIGN_PROCEDURES: controls.DESIGN_PROCEDURES || '-',
        INTERIM_PROCEDURES: controls.INTERIM_PROCEDURES || '-',
        ROLLFORWARD_PROCEDURES: controls.ROLLFORWARD_PROCEDURES || '-',
        FINAL_PROCEDURES: controls.FINAL_PROCEDURES || '-',
        CONTROL_ID: controls.CONTROL_ID,
        appID: controls.id,
    })) : [];
    
    const renderAuditPrepButton = (params) => {
        const app = params.row;
        
        return (
            <Tooltip title="Edit Procedure" arrow>
                <mui.IconButton
                    size="small"
                    onClick={(event) => handleClick(event, app)}
                >
                <OpenInNewIcon sx={{fontSize: '18px'}} />
                </mui.IconButton>
            </Tooltip>
        );
    };

    const columnsWithActions = [
        ...columns,
        {
            field: 'actions',
            headerName: 'Manage',
            width: 200,
            sortable: false,
            renderCell: renderAuditPrepButton,
        },
    ];
    
    const createControls = async (e) => {
        e.preventDefault();

        const savedControlID = localStorage.getItem('controlID');
        if (savedControlID) {
            try {
                const existingProcedure = await auditService.fetchProceduresById(savedControlID);
        
                // If the record exists, update it
                const updatedData = { ...newData, CONTROL_ID: savedControlID };
                const updatedControls = await auditService.updateProcedures(savedControlID, updatedData);
                
                if (updatedControls) {
                    setNewData(updatedControls)
                    setSnackbarMessage('Successfully updated procedures');
                    setSnackbarSeverity('success');
                    setSnackbarOpen(true);
        
                    setTimeout(() => {
                        window.location.reload(); // Reload the page
                    }, 200);
                }
            } catch (error) {
                if (error.response && error.response.status === 404) {
                    // Handle 404 error (record does not exist)
                    try {
                        const newControls = await auditService.createProcedures({ ...newData, CONTROL_ID: savedControlID });
                        
                        if (newControls) {
                            setNewData(newControls)
                            setSnackbarMessage('Successfully created procedures');
                            setSnackbarSeverity('success');
                            setSnackbarOpen(true);
        
                            setTimeout(() => {
                                window.location.reload(); // Reload the page
                            }, 200);
                        }
                    } catch (createError) {
                        console.error('Error creating procedure:', createError);
                        setSnackbarMessage('Failed to create procedures');
                        setSnackbarSeverity('error');
                        setSnackbarOpen(true);
                    }
                } else {
                    // Handle other errors
                    console.error('Error fetching procedure:', error);
                    setSnackbarMessage('An error occurred while fetching procedures');
                    setSnackbarSeverity('error');
                    setSnackbarOpen(true);
                }
            }
        }
        
    };

    const procedurePhaseOptions = [
        { value: 'Design', label: 'Design' },
        { value: 'Interim', label: 'Interim' },
        { value: 'Rollforward', label: 'Rollforward' },
        { value: 'Final', label: 'Final' },
    ];

    useEffect(() => {
        console.log(newData);
    }, [newData]);

    const handleControlChange = (selectedType) => {

        const selectedControl = selectedType.value
        
        setSelectedControl(selectedType)

        setControlID(selectedControl)

        localStorage.setItem('controlID', selectedControl); 

        const selectedProcedure = proceduresData.filter(
            proc => proc.CONTROL_ID === selectedType.value || proc.CONTROL_ID === selectedControl
        );
        
        if (selectedProcedure.length > 0) {
            setExistingProcedure(true);
            const design_procedure = selectedProcedure[0]?.DESIGN_PROCEDURES
            setDesignProcedure(design_procedure);

            const interim_procedure = selectedProcedure[0]?.INTERIM_PROCEDURES
            setInterimProcedure(interim_procedure);

            const rollforward_procedure = selectedProcedure[0]?.ROLLFORWARD_PROCEDURES
            setRollForwardProcedure(rollforward_procedure);

            const final_procedure = selectedProcedure[0]?.FINAL_PROCEDURES
            setFinalProcedure(final_procedure);

            const updatedData = {
                ...newData,
                DESIGN_PROCEDURES: design_procedure,
                INTERIM_PROCEDURES: interim_procedure,
                ROLLFORWARD_PROCEDURES: rollforward_procedure,
                FINAL_PROCEDURES: final_procedure
            };

            setNewData(updatedData)
            console.log(updatedData)

        } else {
            setExistingProcedure(false);
            setDesignProcedure('');
            setInterimProcedure('');
            setRollForwardProcedure('');
            setFinalProcedure('');
        }
    };

    const handleDesignChange = (content) => {

        const sanitizedContent = DOMPurify.sanitize(content);

        if (sanitizedContent) {
            setDesignProcedure(sanitizedContent)

            const updatedData = {
                ...newData,
                DESIGN_PROCEDURES: sanitizedContent
            };

            setNewData(updatedData);

        } else {
            setDesignProcedure('')
        }

    };

    const handleInterimChange = (content) => {

        const sanitizedContent = DOMPurify.sanitize(content);
    
        if (sanitizedContent) {
            setInterimProcedure(sanitizedContent)

            const updatedData = {
                ...newData,
                INTERIM_PROCEDURES: sanitizedContent
            };

            setNewData(updatedData);

        } else {
            setInterimProcedure('')
        }
    };

    const handleRollForwardChange = (content) => {

        const sanitizedContent = DOMPurify.sanitize(content);

        if (sanitizedContent) {
         
        setRollForwardProcedure(sanitizedContent)

        const updatedData = {
            ...newData,
            ROLLFORWARD_PROCEDURES: sanitizedContent
        };

        setNewData(updatedData);

        } else {
            setRollForwardProcedure('')
        }
    };

    const handleFinalChange = (content) => {
        const sanitizedContent = DOMPurify.sanitize(content);

        if (sanitizedContent) {
         
            setFinalProcedure(sanitizedContent)

            const updatedData = {
                ...newData,
                FINAL_PROCEDURES: sanitizedContent
            };
            
            setNewData(updatedData);

            } else {
                setFinalProcedure('')
            }
         
    };

    const modules = {
        toolbar: [
          [{ 'header': [1, 2, false] }],
          [{ 'font': [] }], // Font family options
          [{ 'size': ['small', 'medium', 'large', 'huge'] }], // Font size options
          ['bold', 'italic', 'underline','strike', 'blockquote'],
          [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
          ['clean']
        ],
      }

    const formats = [
        'header',
        'font', // Font family
        'size', // Font size
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent',
       
      ]

    const [errors, setErrors] = useState({
        CONTROL_ID: '',
        CONTROL_TITLE: '',
        CONTROL_DESCRIPTION:'',
    });

    const [isGenerating, setIsGenerating] = useState(false);
    const [generationError, setGenerationError] = useState(null);
    const [procedureStatus, setProcedureStatus] = useState({
        design: 'idle',     // possible states: 'idle', 'generating', 'success', 'error'
        interim: 'idle',
        rollforward: 'idle',
        final: 'idle'
    });

    const generateAllProcedures = async () => {
        if (!selectedControl || !selectedControl.label) {
            setSnackbarMessage('Please select a control first');
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
            return;
        }

        setIsGenerating(true);
        setGenerationError(null);
        
        // Reset all procedure statuses to 'generating'
        setProcedureStatus({
            design: 'generating',
            interim: 'generating',
            rollforward: 'generating',
            final: 'generating'
        });

        try {
            const procedureTypes = ['design', 'interim', 'rollforward', 'final'];
            
            // Process each procedure type sequentially with visual feedback
            let successCount = 0;
            
            for (const type of procedureTypes) {
                try {
                    // Update status to show we're generating this specific procedure
                    setProcedureStatus(prev => ({ ...prev, [type]: 'generating' }));
                    
                    const response = await auditService.generateTestProcedure({
                        control_title: selectedControl.label,
                        procedure_type: type
                    });
                    
                    // Check if response and procedure exist and are valid
                    if (response && response.procedure && typeof response.procedure === 'string') {
                        const procedureText = response.procedure.trim();
                        
                        if (procedureText) {
                            successCount++;
                            switch (type) {
                                case 'design':
                                    setDesignProcedure(procedureText);
                                    handleDesignChange(procedureText);
                                    break;
                                case 'interim':
                                    setInterimProcedure(procedureText);
                                    handleInterimChange(procedureText);
                                    break;
                                case 'rollforward':
                                    setRollForwardProcedure(procedureText);
                                    handleRollForwardChange(procedureText);
                                    break;
                                case 'final':
                                    setFinalProcedure(procedureText);
                                    handleFinalChange(procedureText);
                                    break;
                            }
                            
                            // Update status to success for this procedure
                            setProcedureStatus(prev => ({ ...prev, [type]: 'success' }));
                        } else {
                            // Empty result
                            setProcedureStatus(prev => ({ ...prev, [type]: 'error' }));
                        }
                    } else {
                        // Invalid response
                        setProcedureStatus(prev => ({ ...prev, [type]: 'error' }));
                    }
                } catch (err) {
                    console.error(`Error generating ${type} procedure:`, err);
                    // Update status to error for this procedure
                    setProcedureStatus(prev => ({ ...prev, [type]: 'error' }));
                }
            }
            
            if (successCount > 0) {
                setSnackbarMessage(`Successfully generated ${successCount} procedure${successCount > 1 ? 's' : ''}`);
                setSnackbarSeverity('success');
            } else {
                setSnackbarMessage('No procedures could be generated. Please try again.');
                setSnackbarSeverity('warning');
            }
            setSnackbarOpen(true);
        } catch (error) {
            console.error('Error generating procedures:', error);
            setGenerationError('Failed to generate procedures. Please try again.');
            setSnackbarMessage(`Failed to generate procedures: ${error.message || 'Unknown error'}`);
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
            
            // Set all pending procedures to error state
            setProcedureStatus(prev => {
                const updated = { ...prev };
                Object.keys(updated).forEach(key => {
                    if (updated[key] === 'generating') {
                        updated[key] = 'error';
                    }
                });
                return updated;
            });
        } finally {
            setIsGenerating(false);
        }
    };

    const generateProcedure = async (type) => {
        if (!selectedControl || !selectedControl.label) {
            setSnackbarMessage('Please select a control first');
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
            return;
        }

        setIsGenerating(true);
        setGenerationError(null);
        
        // Update just this procedure's status
        setProcedureStatus(prev => ({ ...prev, [type]: 'generating' }));

        try {
            const response = await auditService.generateTestProcedure({
                control_title: selectedControl.label,
                procedure_type: type
            });
            
            // Check if response and procedure exist and are valid
            if (response && response.procedure && typeof response.procedure === 'string') {
                const procedureText = response.procedure.trim();
                
                if (procedureText) {
                    switch (type) {
                        case 'design':
                            setDesignProcedure(procedureText);
                            handleDesignChange(procedureText);
                            break;
                        case 'interim':
                            setInterimProcedure(procedureText);
                            handleInterimChange(procedureText);
                            break;
                        case 'rollforward':
                            setRollForwardProcedure(procedureText);
                            handleRollForwardChange(procedureText);
                            break;
                        case 'final':
                            setFinalProcedure(procedureText);
                            handleFinalChange(procedureText);
                            break;
                        default:
                            console.warn('Unknown procedure type:', type);
                            break;
                    }
                    
                    setSnackbarMessage(`${type.charAt(0).toUpperCase() + type.slice(1)} procedure generated successfully`);
                    setSnackbarSeverity('success');
                    setSnackbarOpen(true);
                    
                    // Set status to success
                    setProcedureStatus(prev => ({ ...prev, [type]: 'success' }));
                } else {
                    setSnackbarMessage('Generated procedure was empty. Please try again.');
                    setSnackbarSeverity('warning');
                    setSnackbarOpen(true);
                    
                    // Set status to error
                    setProcedureStatus(prev => ({ ...prev, [type]: 'error' }));
                }
            } else {
                throw new Error('Invalid response from AI service');
            }
        } catch (error) {
            console.error(`Error generating ${type} procedure:`, error);
            setGenerationError(`Failed to generate ${type} procedure. Please try again.`);
            setSnackbarMessage(`Failed to generate ${type} procedure: ${error.message || 'Unknown error'}`);
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
            
            // Set status to error
            setProcedureStatus(prev => ({ ...prev, [type]: 'error' }));
        } finally {
            setIsGenerating(false);
        }
    };

    const customMainContent = (
        <div>
            <ResponsiveContainer>
                <mui.Box sx={{ padding: '24px' }}>
                    <mui.Breadcrumbs 
                        aria-label="breadcrumb"
                        sx={{
                            '& .MuiLink-root': {
                                display: 'flex',
                                alignItems: 'center',
                                color: 'text.secondary',
                                fontSize: '0.875rem',
                                transition: 'color 0.2s ease',
                                '&:hover': {
                                    color: 'primary.main'
                                }
                            }
                        }}
                    >
                        <mui.Link underline="hover" color="inherit" href="/dashboard">
                            <i className="material-icons">home</i>
                        </mui.Link>
                        <mui.Link underline="hover" color="inherit" href="/dashboard">
                            My Dashboard
                        </mui.Link>
                        <mui.Typography color="text.primary">Procedures Library</mui.Typography>
                    </mui.Breadcrumbs>

                    <mui.Box sx={{ display: 'flex', alignItems: 'center', mb: 4, mt: 3 }}>
                        <RuleIcon sx={{ fontSize: 32, color: 'primary.main', mr: 2 }} />
                        <mui.Box>
                            <mui.Typography variant="h4" component="h1" sx={{ fontWeight: 600, color: 'text.primary', mb: 1 }}>
                                Procedures Library
                            </mui.Typography>
                            <mui.Typography variant="body1" sx={{ color: 'text.secondary' }}>
                                Manage and document procedures that are used in control testing. Create and customize test procedures for different audit phases.
                            </mui.Typography>
                        </mui.Box>
                    </mui.Box>

                    <mui.Box sx={{ 
                        backgroundColor: '#f8fafc', 
                        borderRadius: 3,
                        minHeight: '80vh',
                        boxShadow: 'inset 0 2px 4px 0 rgb(0 0 0 / 0.05)'
                    }}>
                        <mui.Paper 
                            elevation={0}
                            sx={{ 
                                p: 3,
                                height: '800px',
                                backgroundColor: 'transparent'
                            }}
                        >
                            <ExpandableDataGrid
                                rows={rows}
                                columns={columns}
                                columnsWithActions={columnsWithActions}
                                height={700}
                                expandableFields={['DESIGN_PROCEDURES', 'INTERIM_PROCEDURES', 'ROLLFORWARD_PROCEDURES', 'FINAL_PROCEDURES']}
                                sx={{
                                    '& .MuiDataGrid-root': {
                                        border: 'none',
                                        backgroundColor: 'white',
                                        borderRadius: 2,
                                        overflow: 'hidden',
                                        border: '1px solid',
                                        borderColor: 'rgba(25, 118, 210, 0.08)',
                                        '&:hover': {
                                            borderColor: 'rgba(25, 118, 210, 0.12)'
                                        }
                                    }
                                }}
                            />
                        </mui.Paper>
                    </mui.Box>

                    <CustomSpeedDial 
                        actions={[
                            { 
                                name: 'Create Procedure', 
                                icon: <RuleIcon />, 
                                onClick: () => setOpenModal(true) 
                            }
                        ]} 
                    />

                    <DynamicSnackbar
                        open={snackbarOpen}
                        message={snackbarMessage}
                        severity={snackbarSeverity}
                        onClose={handleSnackbarClose}
                    />

                    <Modal
                        open={openModal}
                        onClose={handleCloseModal}
                        size="lg"
                        body={
                            <mui.Box sx={{ p: 3 }}>
                                <mui.Typography variant="h6" sx={{ mb: 3, fontWeight: 600, color: 'text.primary' }}>
                                    Create Test Procedures
                                </mui.Typography>

                                <div style={{ marginBottom: '24px' }}>
                                    <mui.Typography variant="body2" sx={{ mb: 1, color: 'text.secondary' }}>
                                        Control Name
                                    </mui.Typography>
                                    <MultipleSelect
                                        isMultiSelect={false}
                                        defaultValue={selectedControl ? selectedControl : ''}
                                        placeholderText="Select Control"
                                        selectOptions={controlName ? controlName : ''}
                                        selectedOptions={selectedControl ? selectedControl : ''}
                                        handleChange={handleControlChange}
                                    />
                                </div>

                                {selectedControl && selectedControl.label && (
                                    <mui.Box sx={{ 
                                        mb: 3,
                                        display: 'flex',
                                        justifyContent: 'flex-end'
                                    }}>
                                        <mui.Button
                                            variant="contained"
                                            startIcon={isGenerating ? <CircularProgress size={20} color="inherit" /> : <AutoFixHighIcon />}
                                            onClick={generateAllProcedures}
                                            disabled={isGenerating}
                                            sx={{
                                                bgcolor: 'primary.main',
                                                '&:hover': {
                                                    bgcolor: 'primary.dark',
                                                },
                                                textTransform: 'none',
                                                fontWeight: 500
                                            }}
                                        >
                                            Generate All Procedures
                                        </mui.Button>
                                    </mui.Box>
                                )}

                                <mui.Box sx={{ mt: 3 }}>
                                    <Accordion sx={{
                                        '&.MuiAccordion-root': {
                                            border: '1px solid rgba(25, 118, 210, 0.08)',
                                            borderRadius: 2,
                                            mb: 2,
                                            '&:before': {
                                                display: 'none',
                                            },
                                        }
                                    }}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            sx={{
                                                backgroundColor: 'rgba(25, 118, 210, 0.02)',
                                                borderBottom: '1px solid rgba(25, 118, 210, 0.08)',
                                            }}
                                        >
                                            <mui.Stack direction="row" spacing={1} sx={{ width: '100%' }}>
                                                <mui.Box sx={{ flexGrow: 1 }}>
                                                    <mui.Stack direction="row" spacing={1} alignItems="center">
                                                        <mui.Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                                                            <PagesIcon sx={{ mr: 1, color: 'text.secondary', fontSize: 20 }} />
                                                            Design Procedures
                                                            {procedureStatus.design === 'generating' && (
                                                                <mui.Chip 
                                                                    size="small" 
                                                                    label="Generating..." 
                                                                    color="primary" 
                                                                    variant="outlined"
                                                                    icon={<CircularProgress size={12} />}
                                                                    sx={{ ml: 1, height: '20px', '& .MuiChip-label': { fontSize: '0.7rem', p: '0 6px' } }}
                                                                />
                                                            )}
                                                            {procedureStatus.design === 'success' && (
                                                                <mui.Chip 
                                                                    size="small" 
                                                                    label="Generated" 
                                                                    color="success" 
                                                                    variant="outlined"
                                                                    sx={{ ml: 1, height: '20px', '& .MuiChip-label': { fontSize: '0.7rem', p: '0 6px' } }}
                                                                />
                                                            )}
                                                            {procedureStatus.design === 'error' && (
                                                                <mui.Chip 
                                                                    size="small" 
                                                                    label="Failed" 
                                                                    color="error" 
                                                                    variant="outlined"
                                                                    sx={{ ml: 1, height: '20px', '& .MuiChip-label': { fontSize: '0.7rem', p: '0 6px' } }}
                                                                />
                                                            )}
                                                        </mui.Typography>
                                                    </mui.Stack>
                                                </mui.Box>
                                                <mui.Button
                                                    variant="outlined"
                                                    size="small"
                                                    startIcon={isGenerating ? <CircularProgress size={20} /> : <AutoFixHighIcon />}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        generateProcedure('design');
                                                    }}
                                                    disabled={isGenerating}
                                                    sx={{
                                                        borderColor: 'rgba(25, 118, 210, 0.08)',
                                                        color: 'text.primary',
                                                        '&:hover': {
                                                            borderColor: 'rgba(25, 118, 210, 0.12)',
                                                            backgroundColor: 'rgba(25, 118, 210, 0.04)'
                                                        }
                                                    }}
                                                >
                                                    Generate with Audit-AI
                                                </mui.Button>
                                            </mui.Stack>
                                        </AccordionSummary>
                                        <AccordionDetails sx={{ p: 2 }}>
                                            <mui.Box sx={{ 
                                                '.ql-container': { 
                                                    minHeight: '200px',
                                                    maxHeight: '250px',
                                                    overflow: 'auto',
                                                    border: '1px solid rgba(25, 118, 210, 0.12)',
                                                    borderTop: 'none',
                                                    borderBottomLeftRadius: '4px',
                                                    borderBottomRightRadius: '4px'
                                                },
                                                '.ql-toolbar': {
                                                    border: '1px solid rgba(25, 118, 210, 0.12)',
                                                    borderTopLeftRadius: '4px',
                                                    borderTopRightRadius: '4px'
                                                },
                                                '.ql-editor': {
                                                    minHeight: '200px',
                                                    fontSize: '0.9rem'
                                                }
                                            }}>
                                                <ReactQuill
                                                    theme="snow"
                                                    value={designProcedure}
                                                    onChange={handleDesignChange}
                                                    modules={modules}
                                                    formats={formats}
                                                />
                                            </mui.Box>
                                        </AccordionDetails>
                                    </Accordion>

                                    <Accordion sx={{
                                        '&.MuiAccordion-root': {
                                            border: '1px solid rgba(25, 118, 210, 0.08)',
                                            borderRadius: 2,
                                            mb: 2,
                                            '&:before': {
                                                display: 'none',
                                            },
                                        }
                                    }}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            sx={{
                                                backgroundColor: 'rgba(25, 118, 210, 0.02)',
                                                borderBottom: '1px solid rgba(25, 118, 210, 0.08)',
                                            }}
                                        >
                                            <mui.Stack direction="row" spacing={1} sx={{ width: '100%' }}>
                                                <mui.Box sx={{ flexGrow: 1 }}>
                                                    <mui.Stack direction="row" spacing={1} alignItems="center">
                                                        <mui.Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                                                            <PagesIcon sx={{ mr: 1, color: 'text.secondary', fontSize: 20 }} />
                                                            Interim Procedures
                                                            {procedureStatus.interim === 'generating' && (
                                                                <mui.Chip 
                                                                    size="small" 
                                                                    label="Generating..." 
                                                                    color="primary" 
                                                                    variant="outlined"
                                                                    icon={<CircularProgress size={12} />}
                                                                    sx={{ ml: 1, height: '20px', '& .MuiChip-label': { fontSize: '0.7rem', p: '0 6px' } }}
                                                                />
                                                            )}
                                                            {procedureStatus.interim === 'success' && (
                                                                <mui.Chip 
                                                                    size="small" 
                                                                    label="Generated" 
                                                                    color="success" 
                                                                    variant="outlined"
                                                                    sx={{ ml: 1, height: '20px', '& .MuiChip-label': { fontSize: '0.7rem', p: '0 6px' } }}
                                                                />
                                                            )}
                                                            {procedureStatus.interim === 'error' && (
                                                                <mui.Chip 
                                                                    size="small" 
                                                                    label="Failed" 
                                                                    color="error" 
                                                                    variant="outlined"
                                                                    sx={{ ml: 1, height: '20px', '& .MuiChip-label': { fontSize: '0.7rem', p: '0 6px' } }}
                                                                />
                                                            )}
                                                        </mui.Typography>
                                                    </mui.Stack>
                                                </mui.Box>
                                                <mui.Button
                                                    variant="outlined"
                                                    size="small"
                                                    startIcon={isGenerating ? <CircularProgress size={20} /> : <AutoFixHighIcon />}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        generateProcedure('interim');
                                                    }}
                                                    disabled={isGenerating}
                                                    sx={{
                                                        borderColor: 'rgba(25, 118, 210, 0.08)',
                                                        color: 'text.primary',
                                                        '&:hover': {
                                                            borderColor: 'rgba(25, 118, 210, 0.12)',
                                                            backgroundColor: 'rgba(25, 118, 210, 0.04)'
                                                        }
                                                    }}
                                                >
                                                    Generate with Audit-AI
                                                </mui.Button>
                                            </mui.Stack>
                                        </AccordionSummary>
                                        <AccordionDetails sx={{ p: 2 }}>
                                            <mui.Box sx={{ 
                                                '.ql-container': { 
                                                    minHeight: '200px',
                                                    maxHeight: '250px',
                                                    overflow: 'auto',
                                                    border: '1px solid rgba(25, 118, 210, 0.12)',
                                                    borderTop: 'none',
                                                    borderBottomLeftRadius: '4px',
                                                    borderBottomRightRadius: '4px'
                                                },
                                                '.ql-toolbar': {
                                                    border: '1px solid rgba(25, 118, 210, 0.12)',
                                                    borderTopLeftRadius: '4px',
                                                    borderTopRightRadius: '4px'
                                                },
                                                '.ql-editor': {
                                                    minHeight: '200px',
                                                    fontSize: '0.9rem'
                                                }
                                            }}>
                                                <ReactQuill
                                                    theme="snow"
                                                    value={interimProcedure}
                                                    onChange={handleInterimChange}
                                                    modules={modules}
                                                    formats={formats}
                                                />
                                            </mui.Box>
                                        </AccordionDetails>
                                    </Accordion>

                                    <Accordion sx={{
                                        '&.MuiAccordion-root': {
                                            border: '1px solid rgba(25, 118, 210, 0.08)',
                                            borderRadius: 2,
                                            mb: 2,
                                            '&:before': {
                                                display: 'none',
                                            },
                                        }
                                    }}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            sx={{
                                                backgroundColor: 'rgba(25, 118, 210, 0.02)',
                                                borderBottom: '1px solid rgba(25, 118, 210, 0.08)',
                                            }}
                                        >
                                            <mui.Stack direction="row" spacing={1} sx={{ width: '100%' }}>
                                                <mui.Box sx={{ flexGrow: 1 }}>
                                                    <mui.Stack direction="row" spacing={1} alignItems="center">
                                                        <mui.Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                                                            <PagesIcon sx={{ mr: 1, color: 'text.secondary', fontSize: 20 }} />
                                                            Rollforward Procedures
                                                            {procedureStatus.rollforward === 'generating' && (
                                                                <mui.Chip 
                                                                    size="small" 
                                                                    label="Generating..." 
                                                                    color="primary" 
                                                                    variant="outlined"
                                                                    icon={<CircularProgress size={12} />}
                                                                    sx={{ ml: 1, height: '20px', '& .MuiChip-label': { fontSize: '0.7rem', p: '0 6px' } }}
                                                                />
                                                            )}
                                                            {procedureStatus.rollforward === 'success' && (
                                                                <mui.Chip 
                                                                    size="small" 
                                                                    label="Generated" 
                                                                    color="success" 
                                                                    variant="outlined"
                                                                    sx={{ ml: 1, height: '20px', '& .MuiChip-label': { fontSize: '0.7rem', p: '0 6px' } }}
                                                                />
                                                            )}
                                                            {procedureStatus.rollforward === 'error' && (
                                                                <mui.Chip 
                                                                    size="small" 
                                                                    label="Failed" 
                                                                    color="error" 
                                                                    variant="outlined"
                                                                    sx={{ ml: 1, height: '20px', '& .MuiChip-label': { fontSize: '0.7rem', p: '0 6px' } }}
                                                                />
                                                            )}
                                                        </mui.Typography>
                                                    </mui.Stack>
                                                </mui.Box>
                                                <mui.Button
                                                    variant="outlined"
                                                    size="small"
                                                    startIcon={isGenerating ? <CircularProgress size={20} /> : <AutoFixHighIcon />}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        generateProcedure('rollforward');
                                                    }}
                                                    disabled={isGenerating}
                                                    sx={{
                                                        borderColor: 'rgba(25, 118, 210, 0.08)',
                                                        color: 'text.primary',
                                                        '&:hover': {
                                                            borderColor: 'rgba(25, 118, 210, 0.12)',
                                                            backgroundColor: 'rgba(25, 118, 210, 0.04)'
                                                        }
                                                    }}
                                                >
                                                    Generate with Audit-AI
                                                </mui.Button>
                                            </mui.Stack>
                                        </AccordionSummary>
                                        <AccordionDetails sx={{ p: 2 }}>
                                            <mui.Box sx={{ 
                                                '.ql-container': { 
                                                    minHeight: '200px',
                                                    maxHeight: '250px',
                                                    overflow: 'auto',
                                                    border: '1px solid rgba(25, 118, 210, 0.12)',
                                                    borderTop: 'none',
                                                    borderBottomLeftRadius: '4px',
                                                    borderBottomRightRadius: '4px'
                                                },
                                                '.ql-toolbar': {
                                                    border: '1px solid rgba(25, 118, 210, 0.12)',
                                                    borderTopLeftRadius: '4px',
                                                    borderTopRightRadius: '4px'
                                                },
                                                '.ql-editor': {
                                                    minHeight: '200px',
                                                    fontSize: '0.9rem'
                                                }
                                            }}>
                                                <ReactQuill
                                                    theme="snow"
                                                    value={rollforwardProcedure}
                                                    onChange={handleRollForwardChange}
                                                    modules={modules}
                                                    formats={formats}
                                                />
                                            </mui.Box>
                                        </AccordionDetails>
                                    </Accordion>

                                    <Accordion sx={{
                                        '&.MuiAccordion-root': {
                                            border: '1px solid rgba(25, 118, 210, 0.08)',
                                            borderRadius: 2,
                                            mb: 2,
                                            '&:before': {
                                                display: 'none',
                                            },
                                        }
                                    }}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            sx={{
                                                backgroundColor: 'rgba(25, 118, 210, 0.02)',
                                                borderBottom: '1px solid rgba(25, 118, 210, 0.08)',
                                            }}
                                        >
                                            <mui.Stack direction="row" spacing={1} sx={{ width: '100%' }}>
                                                <mui.Box sx={{ flexGrow: 1 }}>
                                                    <mui.Stack direction="row" spacing={1} alignItems="center">
                                                        <mui.Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                                                            <PagesIcon sx={{ mr: 1, color: 'text.secondary', fontSize: 20 }} />
                                                            Final Procedures
                                                            {procedureStatus.final === 'generating' && (
                                                                <mui.Chip 
                                                                    size="small" 
                                                                    label="Generating..." 
                                                                    color="primary" 
                                                                    variant="outlined"
                                                                    icon={<CircularProgress size={12} />}
                                                                    sx={{ ml: 1, height: '20px', '& .MuiChip-label': { fontSize: '0.7rem', p: '0 6px' } }}
                                                                />
                                                            )}
                                                            {procedureStatus.final === 'success' && (
                                                                <mui.Chip 
                                                                    size="small" 
                                                                    label="Generated" 
                                                                    color="success" 
                                                                    variant="outlined"
                                                                    sx={{ ml: 1, height: '20px', '& .MuiChip-label': { fontSize: '0.7rem', p: '0 6px' } }}
                                                                />
                                                            )}
                                                            {procedureStatus.final === 'error' && (
                                                                <mui.Chip 
                                                                    size="small" 
                                                                    label="Failed" 
                                                                    color="error" 
                                                                    variant="outlined"
                                                                    sx={{ ml: 1, height: '20px', '& .MuiChip-label': { fontSize: '0.7rem', p: '0 6px' } }}
                                                                />
                                                            )}
                                                        </mui.Typography>
                                                    </mui.Stack>
                                                </mui.Box>
                                                <mui.Button
                                                    variant="outlined"
                                                    size="small"
                                                    startIcon={isGenerating ? <CircularProgress size={20} /> : <AutoFixHighIcon />}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        generateProcedure('final');
                                                    }}
                                                    disabled={isGenerating}
                                                    sx={{
                                                        borderColor: 'rgba(25, 118, 210, 0.08)',
                                                        color: 'text.primary',
                                                        '&:hover': {
                                                            borderColor: 'rgba(25, 118, 210, 0.12)',
                                                            backgroundColor: 'rgba(25, 118, 210, 0.04)'
                                                        }
                                                    }}
                                                >
                                                    Generate with Audit-AI
                                                </mui.Button>
                                            </mui.Stack>
                                        </AccordionSummary>
                                        <AccordionDetails sx={{ p: 2 }}>
                                            <mui.Box sx={{ 
                                                '.ql-container': { 
                                                    minHeight: '200px',
                                                    maxHeight: '250px',
                                                    overflow: 'auto',
                                                    border: '1px solid rgba(25, 118, 210, 0.12)',
                                                    borderTop: 'none',
                                                    borderBottomLeftRadius: '4px',
                                                    borderBottomRightRadius: '4px'
                                                },
                                                '.ql-toolbar': {
                                                    border: '1px solid rgba(25, 118, 210, 0.12)',
                                                    borderTopLeftRadius: '4px',
                                                    borderTopRightRadius: '4px'
                                                },
                                                '.ql-editor': {
                                                    minHeight: '200px',
                                                    fontSize: '0.9rem'
                                                }
                                            }}>
                                                <ReactQuill
                                                    theme="snow"
                                                    value={finalProcedure}
                                                    onChange={handleFinalChange}
                                                    modules={modules}
                                                    formats={formats}
                                                />
                                            </mui.Box>
                                        </AccordionDetails>
                                    </Accordion>
                                </mui.Box>
                            </mui.Box>
                        }
                        footer={
                            <mui.Stack direction="row" spacing={2} sx={{ justifyContent: 'flex-end', p: 2 }}>
                                <mui.Button 
                                    onClick={handleCloseModal}
                                    variant="outlined"
                                    sx={{
                                        borderColor: 'rgba(25, 118, 210, 0.08)',
                                        color: 'text.primary',
                                        '&:hover': {
                                            borderColor: 'rgba(25, 118, 210, 0.12)',
                                            backgroundColor: 'rgba(25, 118, 210, 0.04)'
                                        }
                                    }}
                                >
                                    Cancel
                                </mui.Button>
                                <mui.Button 
                                    variant="contained"
                                    onClick={createControls}
                                    sx={{
                                        py: 1,
                                        px: 3,
                                        textTransform: 'none',
                                        fontWeight: 600
                                    }}
                                >
                                    Save Procedure
                                </mui.Button>
                            </mui.Stack>
                        }
                    />
                </mui.Box>
            </ResponsiveContainer>
        </div>
    );

    return (
        <Suspense fallback="Loading...">
            <div>
                <IASideBar mainContent={customMainContent} />
            </div>
        </Suspense>
    );



}
export default ProcedureLibrary;